export const areaCodes = [
    {
        "value": "Heard Island and Mcdonald Islands",
        "label": "+0",
        "code": "HM"
    },
    {
        "value": "United States/Canada",
        "label": "+1",
        "code": "US"
    },
    {
        "value": "Bahamas",
        "label": "+1242",
        "code": "BS"
    },
    {
        "value": "Barbados",
        "label": "+1246",
        "code": "BB"
    },
    {
        "value": "Anguilla",
        "label": "+1264",
        "code": "AI"
    },
    {
        "value": "Antigua and Barbuda",
        "label": "+1268",
        "code": "AG"
    },
    {
        "value": "Virgin Islands, British",
        "label": "+1284",
        "code": "VG"
    },
    {
        "value": "Virgin Islands, U.S.",
        "label": "+1340",
        "code": "VI"
    },
    {
        "value": "Bermuda",
        "label": "+1441",
        "code": "BM"
    },
    {
        "value": "Grenada",
        "label": "+1473",
        "code": "GD"
    },
    {
        "value": "Turks and Caicos Islands",
        "label": "+1649",
        "code": "TC"
    },
    {
        "value": "Montserrat",
        "label": "+1664",
        "code": "MS"
    },
    {
        "value": "Northern Mariana Islands",
        "label": "+1670",
        "code": "MP"
    },
    {
        "value": "Guam",
        "label": "+1671",
        "code": "GU"
    },
    {
        "value": "American Samoa",
        "label": "+1684",
        "code": "AS"
    },
    {
        "value": "Saint Lucia",
        "label": "+1758",
        "code": "LC"
    },
    {
        "value": "Dominica",
        "label": "+1767",
        "code": "DM"
    },
    {
        "value": "Saint Vincent and the Grenadines",
        "label": "+1784",
        "code": "VC"
    },
    {
        "value": "Dominican Republic",
        "label": "+1849",
        "code": "DO"
    },
    {
        "value": "Trinidad and Tobago",
        "label": "+1868",
        "code": "TT"
    },
    {
        "value": "Saint Kitts and Nevis",
        "label": "+1869",
        "code": "KN"
    },
    {
        "value": "Jamaica",
        "label": "+1876",
        "code": "JM"
    },
    {
        "value": "Puerto Rico",
        "label": "+1939",
        "code": "PR"
    },
    {
        "value": "Egypt",
        "label": "+20",
        "code": "EG"
    },
    {
        "value": "South Sudan",
        "label": "+211",
        "code": "SS"
    },
    {
        "value": "Morocco",
        "label": "+212",
        "code": "MA"
    },
    {
        "value": "Algeria",
        "label": "+213",
        "code": "DZ"
    },
    {
        "value": "Tunisia",
        "label": "+216",
        "code": "TN"
    },
    {
        "value": "Libyan Arab Jamahiriya",
        "label": "+218",
        "code": "LY"
    },
    {
        "value": "Gambia",
        "label": "+220",
        "code": "GM"
    },
    {
        "value": "Senegal",
        "label": "+221",
        "code": "SN"
    },
    {
        "value": "Mauritania",
        "label": "+222",
        "code": "MR"
    },
    {
        "value": "Mali",
        "label": "+223",
        "code": "ML"
    },
    {
        "value": "Guinea",
        "label": "+224",
        "code": "GN"
    },
    {
        "value": "Cote d'Ivoire",
        "label": "+225",
        "code": "CI"
    },
    {
        "value": "Burkina Faso",
        "label": "+226",
        "code": "BF"
    },
    {
        "value": "Niger",
        "label": "+227",
        "code": "NE"
    },
    {
        "value": "Togo",
        "label": "+228",
        "code": "TG"
    },
    {
        "value": "Benin",
        "label": "+229",
        "code": "BJ"
    },
    {
        "value": "Mauritius",
        "label": "+230",
        "code": "MU"
    },
    {
        "value": "Liberia",
        "label": "+231",
        "code": "LR"
    },
    {
        "value": "Sierra Leone",
        "label": "+232",
        "code": "SL"
    },
    {
        "value": "Ghana",
        "label": "+233",
        "code": "GH"
    },
    {
        "value": "Nigeria",
        "label": "+234",
        "code": "NG"
    },
    {
        "value": "Chad",
        "label": "+235",
        "code": "TD"
    },
    {
        "value": "Central African Republic",
        "label": "+236",
        "code": "CF"
    },
    {
        "value": "Cameroon",
        "label": "+237",
        "code": "CM"
    },
    {
        "value": "Cape Verde",
        "label": "+238",
        "code": "CV"
    },
    {
        "value": "Sao Tome and Principe",
        "label": "+239",
        "code": "ST"
    },
    {
        "value": "Equatorial Guinea",
        "label": "+240",
        "code": "GQ"
    },
    {
        "value": "Gabon",
        "label": "+241",
        "code": "GA"
    },
    {
        "value": "Congo",
        "label": "+242",
        "code": "CG"
    },
    {
        "value": "Congo, The Democratic Republic of the Congo",
        "label": "+243",
        "code": "CD"
    },
    {
        "value": "Angola",
        "label": "+244",
        "code": "AO"
    },
    {
        "value": "Guinea-Bissau",
        "label": "+245",
        "code": "GW"
    },
    {
        "value": "British Indian Ocean Territory",
        "label": "+246",
        "code": "IO"
    },
    {
        "value": "Seychelles",
        "label": "+248",
        "code": "SC"
    },
    {
        "value": "Sudan",
        "label": "+249",
        "code": "SD"
    },
    {
        "value": "Rwanda",
        "label": "+250",
        "code": "RW"
    },
    {
        "value": "Ethiopia",
        "label": "+251",
        "code": "ET"
    },
    {
        "value": "Somalia",
        "label": "+252",
        "code": "SO"
    },
    {
        "value": "Djibouti",
        "label": "+253",
        "code": "DJ"
    },
    {
        "value": "Kenya",
        "label": "+254",
        "code": "KE"
    },
    {
        "value": "Tanzania, United Republic of Tanzania",
        "label": "+255",
        "code": "TZ"
    },
    {
        "value": "Uganda",
        "label": "+256",
        "code": "UG"
    },
    {
        "value": "Burundi",
        "label": "+257",
        "code": "BI"
    },
    {
        "value": "Mozambique",
        "label": "+258",
        "code": "MZ"
    },
    {
        "value": "Zambia",
        "label": "+260",
        "code": "ZM"
    },
    {
        "value": "Madagascar",
        "label": "+261",
        "code": "MG"
    },
    {
        "value": "French Southern Territories",
        "label": "+262",
        "code": "TF"
    },
    {
        "value": "Mayotte",
        "label": "+262",
        "code": "YT"
    },
    {
        "value": "Reunion",
        "label": "+262",
        "code": "RE"
    },
    {
        "value": "Zimbabwe",
        "label": "+263",
        "code": "ZW"
    },
    {
        "value": "Namibia",
        "label": "+264",
        "code": "NA"
    },
    {
        "value": "Malawi",
        "label": "+265",
        "code": "MW"
    },
    {
        "value": "Lesotho",
        "label": "+266",
        "code": "LS"
    },
    {
        "value": "Botswana",
        "label": "+267",
        "code": "BW"
    },
    {
        "value": "Swaziland",
        "label": "+268",
        "code": "SZ"
    },
    {
        "value": "Comoros",
        "label": "+269",
        "code": "KM"
    },
    {
        "value": "South Africa",
        "label": "+27",
        "code": "ZA"
    },
    {
        "value": "Saint Helena, Ascension and Tristan Da Cunha",
        "label": "+290",
        "code": "SH"
    },
    {
        "value": "Eritrea",
        "label": "+291",
        "code": "ER"
    },
    {
        "value": "Aruba",
        "label": "+297",
        "code": "AW"
    },
    {
        "value": "Faroe Islands",
        "label": "+298",
        "code": "FO"
    },
    {
        "value": "Greenland",
        "label": "+299",
        "code": "GL"
    },
    {
        "value": "Greece",
        "label": "+30",
        "code": "GR"
    },
    {
        "value": "Netherlands",
        "label": "+31",
        "code": "NL"
    },
    {
        "value": "Belgium",
        "label": "+32",
        "code": "BE"
    },
    {
        "value": "France",
        "label": "+33",
        "code": "FR"
    },
    {
        "value": "Spain",
        "label": "+34",
        "code": "ES"
    },
    {
        "value": "Cayman Islands",
        "label": "+345",
        "code": "KY"
    },
    {
        "value": "Gibraltar",
        "label": "+350",
        "code": "GI"
    },
    {
        "value": "Portugal",
        "label": "+351",
        "code": "PT"
    },
    {
        "value": "Luxembourg",
        "label": "+352",
        "code": "LU"
    },
    {
        "value": "Ireland",
        "label": "+353",
        "code": "IE"
    },
    {
        "value": "Iceland",
        "label": "+354",
        "code": "IS"
    },
    {
        "value": "Albania",
        "label": "+355",
        "code": "AL"
    },
    {
        "value": "Malta",
        "label": "+356",
        "code": "MT"
    },
    {
        "value": "Cyprus",
        "label": "+357",
        "code": "CY"
    },
    {
        "value": "Åland Islands",
        "label": "+358",
        "code": "AX"
    },
    {
        "value": "Finland",
        "label": "+358",
        "code": "FI"
    },
    {
        "value": "Bulgaria",
        "label": "+359",
        "code": "BG"
    },
    {
        "value": "Hungary",
        "label": "+36",
        "code": "HU"
    },
    {
        "value": "Lithuania",
        "label": "+370",
        "code": "LT"
    },
    {
        "value": "Latvia",
        "label": "+371",
        "code": "LV"
    },
    {
        "value": "Estonia",
        "label": "+372",
        "code": "EE"
    },
    {
        "value": "Moldova",
        "label": "+373",
        "code": "MD"
    },
    {
        "value": "Armenia",
        "label": "+374",
        "code": "AM"
    },
    {
        "value": "Belarus",
        "label": "+375",
        "code": "BY"
    },
    {
        "value": "Andorra",
        "label": "+376",
        "code": "AD"
    },
    {
        "value": "Monaco",
        "label": "+377",
        "code": "MC"
    },
    {
        "value": "San Marino",
        "label": "+378",
        "code": "SM"
    },
    {
        "value": "Holy See (Vatican City State)",
        "label": "+379",
        "code": "VA"
    },
    {
        "value": "Ukraine",
        "label": "+380",
        "code": "UA"
    },
    {
        "value": "Serbia",
        "label": "+381",
        "code": "RS"
    },
    {
        "value": "Montenegro",
        "label": "+382",
        "code": "ME"
    },
    {
        "value": "Kosovo",
        "label": "+383",
        "code": "XK"
    },
    {
        "value": "Croatia",
        "label": "+385",
        "code": "HR"
    },
    {
        "value": "Slovenia",
        "label": "+386",
        "code": "SI"
    },
    {
        "value": "Bosnia and Herzegovina",
        "label": "+387",
        "code": "BA"
    },
    {
        "value": "Macedonia",
        "label": "+389",
        "code": "MK"
    },
    {
        "value": "Italy",
        "label": "+39",
        "code": "IT"
    },
    {
        "value": "Romania",
        "label": "+40",
        "code": "RO"
    },
    {
        "value": "Switzerland",
        "label": "+41",
        "code": "CH"
    },
    {
        "value": "Czech Republic",
        "label": "+420",
        "code": "CZ"
    },
    {
        "value": "Slovakia",
        "label": "+421",
        "code": "SK"
    },
    {
        "value": "Liechtenstein",
        "label": "+423",
        "code": "LI"
    },
    {
        "value": "Austria",
        "label": "+43",
        "code": "AT"
    },
    {
        "value": "United Kingdom",
        "label": "+44",
        "code": "GB"
    },
    {
        "value": "Denmark",
        "label": "+45",
        "code": "DK"
    },
    {
        "value": "Sweden",
        "label": "+46",
        "code": "SE"
    },
    {
        "value": "Norway",
        "label": "+47",
        "code": "NO"
    },
    {
        "value": "Poland",
        "label": "+48",
        "code": "PL"
    },
    {
        "value": "Germany",
        "label": "+49",
        "code": "DE"
    },
    {
        "value": "Falkland Islands (Malvinas)",
        "label": "+500",
        "code": "FK"
    },
    {
        "value": "Belize",
        "label": "+501",
        "code": "BZ"
    },
    {
        "value": "Guatemala",
        "label": "+502",
        "code": "GT"
    },
    {
        "value": "El Salvador",
        "label": "+503",
        "code": "SV"
    },
    {
        "value": "Honduras",
        "label": "+504",
        "code": "HN"
    },
    {
        "value": "Nicaragua",
        "label": "+505",
        "code": "NI"
    },
    {
        "value": "Costa Rica",
        "label": "+506",
        "code": "CR"
    },
    {
        "value": "Panama",
        "label": "+507",
        "code": "PA"
    },
    {
        "value": "Saint Pierre and Miquelon",
        "label": "+508",
        "code": "PM"
    },
    {
        "value": "Haiti",
        "label": "+509",
        "code": "HT"
    },
    {
        "value": "Peru",
        "label": "+51",
        "code": "PE"
    },
    {
        "value": "Mexico",
        "label": "+52",
        "code": "MX"
    },
    {
        "value": "Cuba",
        "label": "+53",
        "code": "CU"
    },
    {
        "value": "Argentina",
        "label": "+54",
        "code": "AR"
    },
    {
        "value": "Brazil",
        "label": "+55",
        "code": "BR"
    },
    {
        "value": "Chile",
        "label": "+56",
        "code": "CL"
    },
    {
        "value": "Colombia",
        "label": "+57",
        "code": "CO"
    },
    {
        "value": "Venezuela, Bolivarian Republic of Venezuela",
        "label": "+58",
        "code": "VE"
    },
    {
        "value": "Guadeloupe",
        "label": "+590",
        "code": "GP"
    },
    {
        "value": "Saint Barthelemy",
        "label": "+590",
        "code": "BL"
    },
    {
        "value": "Bolivia, Plurinational State of bolivia",
        "label": "+591",
        "code": "BO"
    },
    {
        "value": "Guyana",
        "label": "+592",
        "code": "GY"
    },
    {
        "value": "Ecuador",
        "label": "+593",
        "code": "EC"
    },
    {
        "value": "French Guiana",
        "label": "+594",
        "code": "GF"
    },
    {
        "value": "Paraguay",
        "label": "+595",
        "code": "PY"
    },
    {
        "value": "Martinique",
        "label": "+596",
        "code": "MQ"
    },
    {
        "value": "Surivalue",
        "label": "+597",
        "code": "SR"
    },
    {
        "value": "Uruguay",
        "label": "+598",
        "code": "UY"
    },
    {
        "value": "Netherlands Antilles",
        "label": "+599",
        "code": "AN"
    },
    {
        "value": "Malaysia",
        "label": "+60",
        "code": "MY"
    },
    {
        "value": "Australia",
        "label": "+61",
        "code": "AU"
    },
    {
        "value": "Indonesia",
        "label": "+62",
        "code": "ID"
    },
    {
        "value": "Philippines",
        "label": "+63",
        "code": "PH"
    },
    {
        "value": "New Zealand",
        "label": "+64",
        "code": "NZ"
    },
    {
        "value": "Singapore",
        "label": "+65",
        "code": "SG"
    },
    {
        "value": "Thailand",
        "label": "+66",
        "code": "TH"
    },
    {
        "value": "Timor-Leste",
        "label": "+670",
        "code": "TL"
    },
    {
        "value": "Antarctica",
        "label": "+672",
        "code": "AQ"
    },
    {
        "value": "Brunei Darussalam",
        "label": "+673",
        "code": "BN"
    },
    {
        "value": "Nauru",
        "label": "+674",
        "code": "NR"
    },
    {
        "value": "Papua New Guinea",
        "label": "+675",
        "code": "PG"
    },
    {
        "value": "Tonga",
        "label": "+676",
        "code": "TO"
    },
    {
        "value": "Solomon Islands",
        "label": "+677",
        "code": "SB"
    },
    {
        "value": "Vanuatu",
        "label": "+678",
        "code": "VU"
    },
    {
        "value": "Fiji",
        "label": "+679",
        "code": "FJ"
    },
    {
        "value": "Palau",
        "label": "+680",
        "code": "PW"
    },
    {
        "value": "Wallis and Futuna",
        "label": "+681",
        "code": "WF"
    },
    {
        "value": "Cook Islands",
        "label": "+682",
        "code": "CK"
    },
    {
        "value": "Niue",
        "label": "+683",
        "code": "NU"
    },
    {
        "value": "Samoa",
        "label": "+685",
        "code": "WS"
    },
    {
        "value": "Kiribati",
        "label": "+686",
        "code": "KI"
    },
    {
        "value": "New Caledonia",
        "label": "+687",
        "code": "NC"
    },
    {
        "value": "Tuvalu",
        "label": "+688",
        "code": "TV"
    },
    {
        "value": "French Polynesia",
        "label": "+689",
        "code": "PF"
    },
    {
        "value": "Tokelau",
        "label": "+690",
        "code": "TK"
    },
    {
        "value": "Micronesia, Federated States of Micronesia",
        "label": "+691",
        "code": "FM"
    },
    {
        "value": "Marshall Islands",
        "label": "+692",
        "code": "MH"
    },
    {
        "value": "Russia",
        "label": "+7",
        "code": "RU"
    },
    {
        "value": "Japan",
        "label": "+81",
        "code": "JP"
    },
    {
        "value": "Korea, Republic of South Korea",
        "label": "+82",
        "code": "KR"
    },
    {
        "value": "Vietnam",
        "label": "+84",
        "code": "VN"
    },
    {
        "value": "Korea, Democratic People's Republic of Korea",
        "label": "+850",
        "code": "KP"
    },
    {
        "value": "Hong Kong",
        "label": "+852",
        "code": "HK"
    },
    {
        "value": "Macao",
        "label": "+853",
        "code": "MO"
    },
    {
        "value": "Cambodia",
        "label": "+855",
        "code": "KH"
    },
    {
        "value": "Laos",
        "label": "+856",
        "code": "LA"
    },
    {
        "value": "China",
        "label": "+86",
        "code": "CN"
    },
    {
        "value": "Bangladesh",
        "label": "+880",
        "code": "BD"
    },
    {
        "value": "Taiwan",
        "label": "+886",
        "code": "TW"
    },
    {
        "value": "Turkey",
        "label": "+90",
        "code": "TR"
    },
    {
        "value": "India",
        "label": "+91",
        "code": "IN"
    },
    {
        "value": "Pakistan",
        "label": "+92",
        "code": "PK"
    },
    {
        "value": "Afghanistan",
        "label": "+93",
        "code": "AF"
    },
    {
        "value": "Sri Lanka",
        "label": "+94",
        "code": "LK"
    },
    {
        "value": "Myanmar",
        "label": "+95",
        "code": "MM"
    },
    {
        "value": "Maldives",
        "label": "+960",
        "code": "MV"
    },
    {
        "value": "Lebanon",
        "label": "+961",
        "code": "LB"
    },
    {
        "value": "Jordan",
        "label": "+962",
        "code": "JO"
    },
    {
        "value": "Syrian Arab Republic",
        "label": "+963",
        "code": "SY"
    },
    {
        "value": "Iraq",
        "label": "+964",
        "code": "IQ"
    },
    {
        "value": "Kuwait",
        "label": "+965",
        "code": "KW"
    },
    {
        "value": "Saudi Arabia",
        "label": "+966",
        "code": "SA"
    },
    {
        "value": "Yemen",
        "label": "+967",
        "code": "YE"
    },
    {
        "value": "Oman",
        "label": "+968",
        "code": "OM"
    },
    {
        "value": "Palestinian Territory, Occupied",
        "label": "+970",
        "code": "PS"
    },
    {
        "value": "United Arab Emirates",
        "label": "+971",
        "code": "AE"
    },
    {
        "value": "Israel",
        "label": "+972",
        "code": "IL"
    },
    {
        "value": "Bahrain",
        "label": "+973",
        "code": "BH"
    },
    {
        "value": "Qatar",
        "label": "+974",
        "code": "QA"
    },
    {
        "value": "Bhutan",
        "label": "+975",
        "code": "BT"
    },
    {
        "value": "Mongolia",
        "label": "+976",
        "code": "MN"
    },
    {
        "value": "Nepal",
        "label": "+977",
        "code": "NP"
    },
    {
        "value": "Iran, Islamic Republic of Persian Gulf",
        "label": "+98",
        "code": "IR"
    },
    {
        "value": "Tajikistan",
        "label": "+992",
        "code": "TJ"
    },
    {
        "value": "Turkmenistan",
        "label": "+993",
        "code": "TM"
    },
    {
        "value": "Azerbaijan",
        "label": "+994",
        "code": "AZ"
    },
    {
        "value": "Georgia",
        "label": "+995",
        "code": "GE"
    },
    {
        "value": "Kyrgyzstan",
        "label": "+996",
        "code": "KG"
    },
    {
        "value": "Uzbekistan",
        "label": "+998",
        "code": "UZ"
    }
];